import type { MarketVariants } from '@/lib/i18n'

export type Slide10CloseCopy = {
  title: string
  takeaway1: string
  takeaway2: string
  takeaway3: string
  /** Ends with a "forward" arrow: → in LTR copy, ← in Arabic (RTL). */
  buttonLabel: string
}

export const copy: MarketVariants<Slide10CloseCopy> = {
  US: {
    title: 'Remember',
    takeaway1:
      'You make better decisions when you slow down and give yourself time to think.',
    takeaway2:
      'Always verify through a channel you trust, never one they gave you.',
    takeaway3:
      'Nothing real will fall apart because you took a moment to check.',
    buttonLabel: 'Start Chapter 4: Red Flags →',
  },
  ar: {
    title: 'تذكّر',
    takeaway1:
      'تتخذ قرارات أفضل عندما تتمهّل وتمنح نفسك وقتاً للتفكير.',
    takeaway2:
      'تحقّق دائماً عبر قناة تثق بها، لا عبر قناة أعطوك إياها.',
    takeaway3:
      'لن ينهار شيء حقيقي لأنك أخذت لحظة للتحقق.',
    buttonLabel: 'ابدأ الفصل 4: علامات التحذير ←',
  },
}
